import React from 'react';

export default function StatTile({ label, value, sub, color, icon, className = '' }) {
  return (
    <div className={`stat-tile ${className}`.trim()} style={{ borderLeft: `4px solid ${color || '#e5e7eb'}` }}>
      {icon && <div style={{ fontSize: 20, marginBottom: 4, opacity: 0.7 }}>{icon}</div>}
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: color || '#111827' }}>{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}
